import { IoDocument } from "react-icons/io5";
import ReportsTable from "../../components/reports/ReportsTable";
import { useAuth } from "../../context/AuthContext";
import PageBanner from "../../components/common/PageBanner";

const ReportList = () => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!currentUser) {
    return <div>Please log in to view reports</div>;
  }

  return (
    <div className="py-6 px-10">
      <PageBanner
        icon={<IoDocument />}
        title="Generate Reports"
        description="Create detailed reports from your completed sessions. Each report features a detailed overview of your competency mappings and is downloadable as a PDF."
      />
      <ReportsTable userId={currentUser.id} />
    </div>
  );
};

export default ReportList;
